import { load1Mind } from "./1mind.js";
import { addConsentCallback } from "./lib/onetrust-helpers.js";

const cookieConsentMissing = document.getElementById(
  "1mind-cookie-consent-missing",
);

addConsentCallback(
  "C0001",
  () => {
    cookieConsentMissing?.classList.add("hidden");
    // Load the 1Mind script
    load1Mind();
  },
  () => {
    cookieConsentMissing?.classList.remove("hidden");
  },
);
